import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB_uELtDNdeKuUKGhASQ74_dwGsWnz5ucA",
    authDomain: "pascali-qr.firebaseapp.com",
    projectId: "pascali-qr",
    storageBucket: "pascali-qr.firebasestorage.app",
    messagingSenderId: "930951495730",
    appId: "1:930951495730:web:05cff27118500481217c2b"
  };

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
